import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

import { Select, SelectOption } from '../../../../components/select';
import { ContactTypeFilterIcon } from '../../icons/contact-type';
import { useAnalyticsContext } from '../../providers/analytics-provider';
import { ContactType } from '../registrants/types';

export type ContactTypeAll = ContactType | 'all';
const contactTypeKeys: ContactTypeAll[] = ['all', 'contact', 'registrant'];

const Icon = () => (
  <div className="flex items-center justify-center w-5 h-5">
    <ContactTypeFilterIcon />
  </div>
);

export const ContactTypeFilter = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'analytics.contact-type-filter',
  });

  const { state, dispatch } = useAnalyticsContext();
  const contactType = state.contactType;

  const options: SelectOption<ContactTypeAll>[] = contactTypeKeys.map(
    contactType => ({
      value: contactType,
      label: t(contactType),
    }),
  );

  const handleContactTypeChange = (contactType: ContactTypeAll) => {
    dispatch({
      type: 'update contact filter',
      payload: { contactType },
    });
  };

  return (
    <Select<ContactTypeAll>
      value={contactType}
      onChange={handleContactTypeChange}
      options={options}
      label={contactType ? t(contactType) : t('label')}
      icon={<Icon />}
      className="!h-10 shadow-sm rounded-lg"
      inline
    />
  );
};
